/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Created_ToastInputs */



/**
* | output |
* | --- |
* | "New tag set created" |
*
* @param {Tags_Manager_Created_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_created_toast = /** @type {((inputs?: Tags_Manager_Created_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Created_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nouvel ensemble de tags cree")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neues Tag-Set erstellt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nuovo set di tag creato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создан новый набор тегов.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nuevo conjunto de etiquetas creado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("创建了新的标签集")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいタグセットが作成されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नया टैग सेट बनाया गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Novo conjunto de tags criado")
	return /** @type {LocalizedString} */ ("New tag set created")
});